/* src/app/modules/print-cards/components/cards/card-content/address-cards-1x3/stiiizy-address-card-stack-content/stiiizy-address-card-stack-content.component.scss */
.card-content {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0.25rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
}
.card-content app-stiiizy-address-side-bar {
  width: 0.6875rem;
  height: 100%;
}
/*# sourceMappingURL=stiiizy-address-card-stack-content.component.css.map */
